import React from 'react'

type Props = {
    defaultMessage: string
}

export default class MenuHelp extends React.Component<Props, any> {

    constructor(props:Props) {
        super(props)

        this.state = {
            message: this.props.defaultMessage
        }
    }

    setMessage = (message: any) => {
        this.setState({
            message: message ? message : this.props.defaultMessage
        });
    };

    render() {
        return !this.state.message ? <div className="help"/> : <div className="help">{this.state.message}</div>;
    }
}